import React, { Fragment } from 'react'
import MetaData from '../../meta-data/meta-data'

const Hull = () => {
  return (
    <Fragment>
      <MetaData
        metaTitle={'Hull page'}
        metaDescription={'this is a hull page'}
        metaContent={{ robots: 'noindex,nofollow' }}
      />
      <Fragment>
        <h1>Hello</h1>
      </Fragment>
    </Fragment>
  )
}

export default Hull
